export default "__VITE_ASSET__1761175b__"